import React from "react";

const ProductCardsRow = ({ data }: any) => {
  return <div>{data.Text}</div>;
};

export default ProductCardsRow;
